import { Flex } from "@mantine/core";
import colorsCustom from "../../designTokens/colorsCustom";
import styled from "styled-components";

const Container = styled(Flex)`
	border-style: solid;
	border-color: ${colorsCustom.ui.dark.bold};
	border-width: ${(props) => {
		if (props.$borderType === 'bottom') {
			return props.$weight === 'bold' ? '0 0 4px 0' : '0 0 2px 0';
		}
		return props.$weight === 'bold' ? '1px 4px 4px 1px' : '0.5px 3px 3px 0.5px';
	}};
	border-radius: ${(props) => `${props.rd}px` || "16px"};
	overflow: hidden;
`;

export const MessageContainer = ({
	children,
	bg = "#ffffff",
	w = "auto",
	rd = 16,
	p = "12px 16px",
	weight = 'bold',
	borderType = 'full',
	style,
}) => (
	<Container $weight={weight} p={p} rd={rd} bg={bg} w={w} $borderType={borderType} style={style}>
		{children}
	</Container>
); 